import {ThreadListView} from '@github-ui/copilot-chat/components/ThreadListView'
import {useChatStateValues} from '@github-ui/copilot-chat/CopilotChatContext'
import {ConversationView} from '@github-ui/copilot-immersive-v1/components/ConversationView'
import {Spinner} from '@primer/react'

import styles from './CopilotChatPanelContent.module.css'

export interface CopilotChatPanelContentProps {
  inputRef: React.RefObject<HTMLTextAreaElement | null>
  isInitialLoading: boolean
  forceIconOnly?: boolean
}

export function CopilotChatPanelContent({inputRef, isInitialLoading, forceIconOnly}: CopilotChatPanelContentProps) {
  const {currentView} = useChatStateValues('currentView')

  if (isInitialLoading) {
    return (
      <div className={styles.loadingContainer}>
        <Spinner size="large" srText="Loading conversation..." />
      </div>
    )
  }

  if (currentView === 'list') {
    return <ThreadListView />
  }

  return (
    <ConversationView
      attachmentMenuSide="outside-top"
      isMobile
      textAreaRef={inputRef}
      forceIconOnly={forceIconOnly}
      isEmbedded
    />
  )
}
